import Skeleton from "react-loading-skeleton";

interface SkeletonWaveProps {
  count?: number;
  height?: number;
  borderRadius?: string;
  className?: string;
  delay?: number;
  marginBottom?: number;
}

export const SkeletonWave = ({
  count = 3,
  height = 208,
  borderRadius = "10px",
  className = "",
  delay = 0.15,
  marginBottom = 16,
}: SkeletonWaveProps) => {
  return (
    <div className={className}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="skeleton-wave-item"
          style={{
            animationDelay: `${index * delay}s`,
            marginBottom,
          }}
        >
          <Skeleton count={1} style={{ height }} borderRadius={borderRadius} />
        </div>
      ))}
    </div>
  );
};
